import classNames from 'classnames'
import React from 'react'
import {Text, TextTypography} from 'wix-ui-tpa/cssVars'
import {useMobileFontOverrides} from '../../../../../../commons/hooks/use-mobile-font-overrides'
import {classes} from './page-title.st.css'

export const PageTitle = ({mobile, ...props}) => {
  const {mobileFontOverridesEnabled} = useMobileFontOverrides()
  return (
    <Text
      typography={TextTypography.largeTitle}
      {...props}
      className={classNames(classes.root, {[classes.mobile]: mobile && mobileFontOverridesEnabled})}
      tagName="h2"
    />
  )
}
